import { render, staticRenderFns } from "./EduHeader.vue?vue&type=template&id=86cc4636&scoped=true"
import script from "./EduHeader.vue?vue&type=script&lang=js"
export * from "./EduHeader.vue?vue&type=script&lang=js"
import style0 from "./EduHeader.vue?vue&type=style&index=0&id=86cc4636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cc4636",
  null
  
)

export default component.exports